import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import RouteManager from "../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES, TABLE_DISPLAY_NAME } from '../../managers/TableManger';
import { fetchFilteredPayschedules, fetchPayschedules, fetchUsers, selectPaySchedule, selectUsers } from '../../Redux/Slices/PayrollSlice';
import PayrollService from '../../services/PayrollService';
import Table from "../../services/table";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { parseColumnConfig, parseVisibleColumnConfig, PayScheduleColumnConfig } from '../configs/config';
import { showLoader, removeLoader, showToast, TOAST_TYPE, DKFilterPopup } from 'deskera-ui-library';
import { showPaySchedulePopup } from "../../SharedComponents/AddEditPaySchedule";
import { PayScheduleManager } from "../../managers/PayScheduleManager";
import ReadWatchComponent from "../common/ReadWatchComponent";
import AppManager from "../../managers/AppManager";
import { fetchCustomFields, selectCustomField } from "../../Redux/Slices/CustomFieldsSlice";
import { fetchLocationDimentionList, fetchLocationList, selectLocationDimentionList, selectLocationList } from "../../Redux/Slices/LocationListSlice";
import CustomFieldService from "../../services/CustomFieldService";
import TenantManager from "../../managers/TenantManager";
import { LOCATION_COLUMN_CONFIG } from "../add-employee/steps/Employee";
import { INPUT_TYPE } from "../../constants/Constant";
import AddEditPayschedule from "./AddEditPayschedule";
import {DKLabel, DKButton, DKIcons} from "deskera-ui-library";
import { convertDateToJson } from "../../managers/common/CommonUtil";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";



const PayScheduleGrid = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: {},
        filter: {}
    };

    const dispatch = useDispatch();
    const users = useSelector(selectUsers);
    const payScheduleList = useSelector(selectPaySchedule);
    const locationData = useSelector(selectLocationList);
    const customFieldsData = useSelector(selectCustomField);

    const [paySchedule, setPaySchedule] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [showList, setFiltersList] = useState(true);
    const [reload, setReload] = useState(false);
    const isActionEnabled = true;
    const [conditionFilter, setConditionFilter] = useState([]);
    const [filterArray, setFilterArray] = useState([]);
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails);
    const [isFilterEnabled, setIsFilterEnabled] = useState(false);
    const [addEditPopupConfig, setAddEditPopupConfig] = useState({
        visibility : false,
        data : {},
        defaultValues: {},
        isEdit: false
    });
    const [usersMapValues, setUsersMapValues] = useState(new Map());
    const [userPopUpData, setUserIdPopup] = useState({
        enable: false,
        iamUserIds: [],
        users: []
    });
    const [needFilterPopup, setFilterPop] = useState(false)


    useEffect(() => {
        RouteManager.setPresenter({ props });
        if(!Utility.isEmpty(users) || users.length === 0) {
            loadUsersList({})
        }
        // if (Utility.isEmpty(payScheduleList)) {
        loadPayScheduleList({})
        const tenantDetails = TenantManager.getTenantDetails()
        const additionalSettings = tenantDetails
            ? tenantDetails.additionalSettings
            : "";
        const locationSettings = additionalSettings ? additionalSettings?.['LOCATION'] : {};
        const trackLocation = locationSettings?.trackLocation || false;
        if (trackLocation) {
            loadLocationList()
        }
        loadCustomFields({});

        window.openUsersList = (iamUserIds) => {
            setUserIdPopup({
                enable: true,
                iamUserIds: Utility.decodeJSON(iamUserIds),
                users: usersMapValues
            })
        }
        document.addEventListener("keydown", bindEscape);

        return () => {
            window.openUsersList = null;
            if(PayrollService.payscheduleFilterArray) {
                PayrollService.payscheduleFilterArray = null;
            }
            document.removeEventListener("keydown", bindEscape);
            setPaySchedule(initialState)
        }
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(users)) {
            const userList = users?.users;
            const usersMap = getUsersMap(userList);
            setUsersMapValues(usersMap);
        }
    }, [users])

    useEffect(() => {
        if (!Utility.isEmpty(payScheduleList)) {
            const { schedules, filterResponse } = payScheduleList;
            const { tenant } = TenantManager.getPeopleTenantData();
            const { customFields } = customFieldsData;
            const rowData = PayScheduleColumnConfig(schedules, tenantDetails, customFields, usersMapValues);
            let { isLocationActive } = getLocationActiveStatus();
            let payScheduleColumn = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PAY_SCHEDULE), TABLES.PAY_SCHEDULE))
            payScheduleColumn = isLocationActive ? updateEmployeeColumnConfig(payScheduleColumn) : payScheduleColumn;
            payScheduleColumn = updateColumnConfigWithCustomField(payScheduleColumn);
            const passingData = {
                columnData: deepClone(payScheduleColumn),
                rowData,
                filter: [],
                originalData: schedules
            };
            const isFilterListEnabled = payScheduleList.length > 0 ? true : false;
            showLoader();
            setIsFilterEnabled(isLocationActive || customFields?.length > 0);
            setPaySchedule(passingData);
            setTotalPageCount(payScheduleList.filter ? payScheduleList.filter.totalPages : 0);
            setCurrentPage(payScheduleList.filter ? payScheduleList.filter.currentPage + 1 : 1);
            setTotalCount(payScheduleList.filter ? payScheduleList.filter.totalCount : 0)
            setFiltersList(isFilterListEnabled)
            removeLoader()
            
        }

    }, [payScheduleList,locationData, reload, usersMapValues]);

    const getUsersMap = (users) => {
        const map = new Map();
        users?.forEach((u) => {
            map.set(u.userId, u);
        })
        return map;
    }

    const loadPayScheduleList = async (config) => {
        try {
            config = {
                Limit: 10000,
                CurrentPage: 1,
                Order: 'desc',
                Field: "_id"
            }
            PayrollService.apiConfig = config;
            const timeout = showDelayedLoader();
            if(PayrollService?.payscheduleFilterArray?.length > 0) {
                await dispatch(fetchFilteredPayschedules());
            } else {
                await dispatch(fetchPayschedules());
            }
            removeDelayedLoader(timeout);
        } catch (err) {
            console.error('Error loading pay schedules: ', err);
        }
    }

    const loadUsersList = async (config) => {
        try {
            await dispatch(fetchUsers());
        } catch (err) {
            console.error('Error loading users: ', err);
        }
    }
    const loadLocationList = async () => {
        try {
          await dispatch(fetchLocationList());
        } catch (err) {
          console.error("Error loading location data: ", err);
        }
      };
    const loadLocationDimenionData = async () => {
        try {
            await dispatch(fetchLocationDimentionList());
        } catch (err) {
            console.error("Error loading tenant data: ", err);
        }
    };

    const loadCustomFields = async (config) => {
        try {
            config = {
                ...CustomFieldService.apiConfig,
                Module: "payschedule",
            };
            CustomFieldService.apiConfig = config;
            await dispatch(fetchCustomFields());
        } catch (err) {
            console.error("Error loading custom fields data: ", err);
        }
    };


    const deletePaySchedule = (data) => {
        const rowData = data && data.rowData ? data.rowData : data.length>0 ? data[0] : "";
        let payScheduleId = []

        if(data && data.rowData) {
            let params = {
                'scheduleId': rowData.id
            }
            payScheduleId = [params]
        } else if(data.length>0){
           data.forEach(paySchedule => {
               let params = {
                    'scheduleId': paySchedule.id
                }
               payScheduleId.push(params)
            })
        }
        showLoader('Pay schedule is being deleted');
        (Table.deletePaySchedule(payScheduleId)
        ).finally(() => removeLoader())
            .then(
                (res) => {
                    showToast(
                        'Pay schedule deleted',
                        TOAST_TYPE.SUCCESS
                    );
                    loadPayScheduleList(PayrollService.config)
                },
                (err) => {
                    showToast(
                        "Some Unknown Error Occurred at Server.Please Try Again!",
                        TOAST_TYPE.FAILURE
                    );
                }
            );
    }

    const onCreateNew = (row = {}) => {
        setFilterPop(false)
        let usersList = users ? users.users : [];
        setAddEditPopupConfig({
            visibility : true,
            isEdit : false,
            data:{
                locationData:locationData,
                customFieldsData:customFieldsData,
                userList:usersList
            },
            defaultValues:PayScheduleManager.getAddPayscheduleDefaultValues(customFieldsData),
        });
    }

    const onRowEdit = (data, state) => {
        setFilterPop(false)
        const rowData = data && data.rowData ? data.rowData : data.length > 0 ? data[0] : "";
        if (rowData) {
            const payScheduleId = rowData.id;
            const { schedules, filterResponse } = payScheduleList;
            const selectedPaySchedule = schedules.filter(x => x.id === payScheduleId);
            if (selectedPaySchedule && selectedPaySchedule.length > 0) {
                let dataToEdit = selectedPaySchedule[0];
                // PayrollManager.getPayrollDefaultValues(dataToEdit);
                let usersList = users ? users.users : [];
                let defaultValues = PayScheduleManager.getPayScheduleDefaultValues(dataToEdit, customFieldsData)
                setAddEditPopupConfig({
                    visibility : true,
                    isEdit: true,
                    data:{
                        locationData:locationData,
                        customFieldsData:customFieldsData,
                        userList:usersList
                    },
                    defaultValues:defaultValues,
                })
            }

        }

    };

    const onFilter = (updatedList, queries) => {
        PayrollService.conditionalPayscheduleConfig = null;
        if(!Utility.isEmpty(queries.length)) {
            const conditions = [];
            queries.forEach((q) => {
                const { isLocationActive, locationSettings } = getLocationActiveStatus();
                const columnName = isLocationActive ? locationSettings?.locationLabel : "";
                let group = {
                    opr: q.condition
                };
                let isDateFilter = false;
                let index = customFieldsData?.customFields.findIndex(c => c.id === q.key);
                if (index != -1 && customFieldsData?.customFields[index].type === "date") {
                  isDateFilter = true;
                }
                if(columnName === q.key) {
                    group["colId"] = "location";
                    group["key"] = "location";
                } else {
                    group["colId"] = q.key;
                    group["key"] = "customField";
                }
                if(Array.isArray(q.value) && !Utility.isEmpty(q.value.length)) {
                    group["value"] = q.value[0].toString();
                } else if (isDateFilter) {
                    group["value"] = convertDateToJson(q.value);
                } else {
                    group["value"] = q.value;
                }
                conditions.push(group);
            });
            const params = {
                conditions : conditions,
                isFilterEnabled : true
            };
            PayrollService.conditionalPayscheduleConfig = params;
            setConditionFilter(params);
        }
        PayrollService.payscheduleFilterArray = queries;
        setFilterArray(queries);
        let config = {
            ...PayrollService.apiConfig,
            CurrentPage: 1,
          }
        loadPayScheduleList(config);
    };

    const getLocationActiveStatus = () => {
        let isLocationActive = false;
        const { additionalSettings } = tenantDetails || "";
        const locationSettings = additionalSettings
            ? additionalSettings?.["LOCATION"]
            : {};
        isLocationActive = locationSettings?.trackLocation || false;

        return {isLocationActive, locationSettings};
    }

    const updateEmployeeColumnConfig = (columnConfig) => {
        const { isLocationActive, locationSettings } = getLocationActiveStatus();
        const columnName = isLocationActive ? locationSettings?.locationLabel : "";
        const locationColumn = LOCATION_COLUMN_CONFIG;
        const locationList = locationData?locationData : []
        const locationOptions = locationList && locationList.map((x) => {
            return {
                id: x.id,
                name: x.label,
                ...x
            };
        });
        locationColumn["name"] = columnName;
        locationColumn["columnCode"] = columnName;
        locationColumn["key"] = columnName;
        locationColumn["id"] = columnName;
        locationColumn["options"] = locationOptions;
        columnConfig.push(locationColumn)
        return columnConfig;
    }

    const updateColumnConfigWithCustomField = (columnConfig) => {
        let fieldConfig  = customFieldsData?.customFields?.filter(field=>field.isActive) || [];
        fieldConfig?.forEach((c) => {
            let group = {
                name:c.name,
                columnCode:c.id,
                id:c.id,
                key:c.id,
                width:150,
                editable:false,
                uiVisible :true
            };
            group = getFieldConfigOnType(group,c);
            columnConfig.push(group);
        });
        return columnConfig;
    }

    const getFieldConfigOnType = (group, c) => {
        switch(c.type) {
            case "text":
                group['type'] = INPUT_TYPE.TEXT;
                break;
            case "number":
                group['type'] = INPUT_TYPE.NUMBER;
                break;
            case "multiselect":
                const options = c.possibleValues.map((p) => {
                    return{
                        id:p,
                        name:p
                    }
                });
                group['type'] = INPUT_TYPE.MULTI_SELECT;
                group['options'] = options;
                break;
            case "date":
                group['type'] = INPUT_TYPE.DATE;
                break;    
            default:
                group['type'] = INPUT_TYPE.TEXT;
        }
        return group;
    }


    const onContextCancel = () => {
        setReload(!reload)
    }

    const onPopupClose = (isReload) => {
        setAddEditPopupConfig({
            visibility : false
        })
        if(isReload) {
            loadPayScheduleList({})
        }
    }

    const onUserIdPopClose = () => {
        setUserIdPopup(false);
    }
    const getButtonConfig = () => {
        let buttons = [{
            title: "+ Add Pay Schedule",
            className: "bg-app text-white ml-s",
            onClick: () => onCreateNew(),
        }]
        if (isFilterEnabled) {
            const noteBtn = {
                title: "",
                icon: "",
                className: "position-absolute bg-red filter-note p-0",
                onClick: () => {},
            }
            if(filterArray && filterArray.length !== 0) {
                buttons.push(noteBtn)
            }
            buttons.push(
                {
                title: "",
                icon: needFilterPopup ? DKIcons.ic_close : DKIcons.ic_filter,
                className: "bg-white border-m ml-s",
                onClick: () => {
                    setFilterPop(!needFilterPopup)
                },
                }
            )
        }
        return buttons;
    }
    const getFilterPopup = ()=> {
        return (
            <div className="filter filter-position">
                <DKFilterPopup
                    filterData={[...filterArray]}
                    headers={getUpdatedFilterableColumns()}
                    onSubmit={(data, operator) => {
                        onFilter([], data);
                        setFilterPop(false)
                    }}
                    onCancel={() => {
                        setFilterArray([]);
                        onFilter([], []);
                        setFilterPop(false)
                    }}
                />
            </div>
        );
      }
      const getUpdatedFilterableColumns = () => {
        return (
            paySchedule?.columnData?.filter((obj) => {
                    return (
                        obj.type &&
                        obj.type !== INPUT_TYPE.BUTTON &&
                        obj.type !== INPUT_TYPE.MORE &&
                        (obj.allowFilter ?? true)
                    );
                })
                .map((obj) => {
                    return obj;
                }) || []
        );
    };
    const bindEscape = (evt) => {
        evt = evt || window.event;
        if (evt.keyCode === 27) {
          setFilterPop(false)
        }
    };
    const onRowClick = () =>{
        if(needFilterPopup) {
            setFilterPop(false);
        }
    }

    return (
        <>
        <ReadWatchComponent 
                    title = "Need help getting started? Learn more about creating Pay schedule."
                    onRead = { () => window.open(
                        "https://www.deskera.com/care/add-pay-schedules-deskera-hris/",
                        "_blank"
                      )}
                    onWatch = { AppManager.showComingSoonWarning}
                />
        <div className="column parent-width flex-1 parent-height">
            <div className="column parent-width mb-s position-relative flex-1 parent-width">
                
                <DataGridHolderPayroll
                    tableName={TABLES.PAY_SCHEDULE}
                    displayTableName={TABLE_DISPLAY_NAME[TABLES.PAY_SCHEDULE]}
                    allowRowEdit={PermissionUtils.hasAccess(MODULE.PAY_SCHEDULE,[ACTION.EDIT])}
                    allowColumnEdit={true}
                    allowColumnDelete={true}
                    onRowEdit={(data) => {
                        onRowEdit(data)
                    }}
                    onCancelContext={() => {
                        onContextCancel()
                    }}
                    onRowDelete={(data) => {
                        deletePaySchedule(data)
                    }}
                    allowRowAdd={true}
                    allowColumnAdd={false}
                    allowColumnDelete={true}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    addButtonConfig={getButtonConfig()}
                    allowDataExport={true}
                    gridData={paySchedule}
                    onFilter={onFilter}
                    filter={filterArray}
                    currentPage={currentPage}
                    totalPageCount={totalPageCount}
                    isActionEnabled={isActionEnabled}
                    isMenuVisible={true}
                    contextMenu={true}
                    onRowClick={onRowClick}
                    onColumnShift={(data)=> setReload(!reload)}
                    module={MODULE.PAY_SCHEDULE}
                />
                {(needFilterPopup && isFilterEnabled) && getFilterPopup()}
            </div>
        </div>
        {addEditPopupConfig.visibility && <AddEditPayschedule isEdit={addEditPopupConfig.isEdit} data={addEditPopupConfig.data} defaultValues={addEditPopupConfig.defaultValues} onClose={(isReload) => onPopupClose(isReload)} />}
        { userPopUpData.enable && (
                <>
                    <div className=" transparent-background">
                        <div className="p-h-r pt-r pb-m popup-window custom-popup-outer" style={{ padding: 0, maxWidth: "25%", width: "100%", overflow: "hidden" }} >
                            
                                <div className="row justify-content-between p-h-m p-v-s bg-gray2">
                                    <DKLabel text={"Payschedule is Applicable to"} className="fs-l fw-m" />
                                    <DKButton icon={DKIcons.ic_close} onClick={() => onUserIdPopClose(false)} />
                                </div>
                                <div
                                    className=" parent-width p-m custom-popup-body"
                                >
                                    {userPopUpData.iamUserIds.map((i, index) => {
                                        return (
                                            <>
                                                <div className="pb-s">
                                                    <div className="row fs-m">
                                                        <div>{`${index + 1}. ${usersMapValues.get(i).firstName} ` + `${usersMapValues.get(i).lastName}`}</div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>

                </>
            )}
            
    </>
    )
}

export default PayScheduleGrid
